import React from "react";
import { Container } from "./styled/tip";

function Tip(props) {
  return <Container {...props} />;
}

export default Tip;
